module.exports = __webpack_public_path__ + "img/dbpiep.36972de4.png";